// import React, { useState, useEffect } from "react";
// import DataTable from "react-data-table-component";
// import toast from "react-hot-toast";
// import HomeService from "../Services/HomeService";
// import moment from "moment";

// const headLineStyle = {
//   textAlign: "center",
//   fontSize: "30px",
//   color: "#868e96",
//   margin: "15px",
//   fontWeight: "bold",
// };

// function ManagePersonalService() {
//   const [personalServices, setPersonalServices] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editId, setEditId] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [imageLoading, setImageLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     image: "",
//     heading: "",
//     subheading: "",
//   });

//   // Fetch data on component mount
//   useEffect(() => {
//     fetchPersonalServices();
//   }, []);

//   // Fetch all personal services
//   const fetchPersonalServices = async () => {
//     setLoading(true);
//     try {
//       const res = await HomeService.getPersonalService();
//       if (res?.data) {
//         setPersonalServices(res.data);
//       }
//     } catch (error) {
//       console.error("Error fetching personal services:", error);
//       toast.error("Failed to fetch personal services");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle edit button click
//   const handleEdit = (service) => {
//     console.log("Editing service:", service);
//     setIsEditing(true);
//     setEditId(service._id);

//     setFormData({
//       image: service.image || "",
//       heading: service.heading || "",
//       subheading: service.subheading || "",
//     });

//     // Scroll to edit section
//     const editSection = document.getElementById("edit-section");
//     if (editSection) {
//       editSection.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   // Handle delete button click
//   const handleDelete = async (id) => {
//     if (
//       window.confirm("Are you sure you want to delete this personal service?")
//     ) {
//       try {
//         const res = await HomeService.deletePersonalService(id);
//         if (res?.status) {
//           toast.success("Personal service deleted successfully!");
//           fetchPersonalServices();
//         } else {
//           toast.error(res?.message || "Failed to delete service");
//         }
//       } catch (error) {
//         console.error("Error deleting personal service:", error);
//         toast.error(error?.message || "Failed to delete service");
//       }
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     // Validate image file
//     if (!file.type.startsWith("image/")) {
//       toast.error("Please select a valid image file");
//       return;
//     }

//     setImageLoading(true);

//     const data = new FormData();
//     data.append("image", file);

//     try {
//       const res = await HomeService.uploadImage(data); // Assuming you have uploadImage function
//       if (res?.image) {
//         setFormData((prev) => ({ ...prev, image: res.image }));
//         toast.success("Image uploaded successfully!");
//       } else {
//         toast.error(res?.message || "Failed to upload image");
//       }
//     } catch (error) {
//       toast.error("Failed to upload image.");
//       console.error("Error uploading image:", error);
//     } finally {
//       setImageLoading(false);
//     }
//   };

//   // Handle form submission (for update only)
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validation
//     if (!formData.image) {
//       toast.error("Please upload an image");
//       return;
//     }

//     if (!formData.heading.trim()) {
//       toast.error("Please enter a heading");
//       return;
//     }

//     if (!formData.subheading.trim()) {
//       toast.error("Please enter a subheading");
//       return;
//     }

//     const data = {
//       image: formData.image,
//       heading: formData.heading.trim(),
//       subheading: formData.subheading.trim(),
//     };

//     setIsSubmitting(true);
//     try {
//       // Update existing service
//       const res = await HomeService.updatePersonalService(editId, data);
//       if (res?.status) {
//         toast.success("Personal service updated successfully!");
//         resetForm();
//         fetchPersonalServices();
//       } else {
//         toast.error(res?.message || "Failed to update service");
//       }
//     } catch (error) {
//       console.error("Error updating personal service:", error);
//       toast.error(error?.message || "Failed to update service");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Reset form
//   const resetForm = () => {
//     setIsEditing(false);
//     setEditId("");
//     setFormData({
//       image: "",
//       heading: "",
//       subheading: "",
//     });
//   };

//   // Handle cancel edit
//   const handleCancel = () => {
//     resetForm();
//   };

//   const removeImage = () => {
//     setFormData((prev) => ({ ...prev, image: "" }));
//     toast.success("Image removed");
//   };

//   // DataTable columns
//   const columns = [
//     {
//       name: "Sl#",
//       selector: (row, index) => index + 1,
//       sortable: true,
//       width: "80px",
//     },
//     {
//       name: "Image",
//       cell: (row) => (
//         <img
//           src={row.image}
//           alt={row.heading}
//           style={{
//             width: "80px",
//             height: "60px",
//             objectFit: "cover",
//             borderRadius: "5px",
//             border: "1px solid #ddd",
//           }}
//         />
//       ),
//       width: "100px",
//     },
//     {
//       name: "Heading",
//       selector: (row) => row.heading,
//       sortable: true,
//       wrap: true,
//     },
//     {
//       name: "Subheading",
//       selector: (row) => row.subheading,
//       wrap: true,
//       cell: (row) => (
//         <div style={{ maxWidth: "300px", whiteSpace: "normal" }}>
//           {row.subheading}
//         </div>
//       ),
//     },
//     {
//       name: "Created Date",
//       selector: (row) =>
//         moment(row.createdAt || row.createdOn).format("DD/MM/YYYY"),
//       sortable: true,
//       width: "150px",
//     },
//     {
//       name: "Actions",
//       cell: (row) => (
//         <div>
//           <button
//             className="btn btn-sm btn-primary mr-2"
//             onClick={() => handleEdit(row)}
//             title="Edit"
//           >
//             <i className="fas fa-edit"></i>
//           </button>
//           <button
//             className="btn btn-sm btn-danger"
//             onClick={() => handleDelete(row._id)}
//             title="Delete"
//           >
//             <i className="fas fa-trash"></i>
//           </button>
//         </div>
//       ),
//       width: "120px",
//     },
//   ];

//   // Custom styles for DataTable
//   const customStyles = {
//     headCells: {
//       style: {
//         backgroundColor: "#f8f9fa",
//         fontWeight: "bold",
//         fontSize: "14px",
//       },
//     },
//     cells: {
//       style: {
//         fontSize: "13px",
//       },
//     },
//   };

//   return (
//     <div className="main_wrap" style={{ marginTop: "6rem" }}>
//       <div className="container-fluid">
//         <div className="mt-5">
//           <h2 className="text-center" style={headLineStyle}>
//             Manage Personal Services
//           </h2>
//           <hr />

//           {/* Edit Form Section (Only shown when editing) */}
//           {isEditing && (
//             <section className="chartBox_area" id="edit-section">
//               <div className="row">
//                 <div className="col-lg-12">
//                   <div className="card">
//                     <div className="card-header">
//                       <h5 className="mb-0">Edit Personal Service</h5>
//                     </div>
//                     <div className="card-body">
//                       <form onSubmit={handleSubmit}>
//                         <div className="row">
//                           {/* Image Upload Section */}
//                           <div className="col-md-6 mt-3">
//                             <label htmlFor="image">
//                               Upload Image<span className="text-danger">*</span>
//                             </label>
//                             <input
//                               type="file"
//                               id="image"
//                               className="form-control"
//                               onChange={handleImageUpload}
//                               accept="image/*"
//                               disabled={imageLoading}
//                               required
//                             />
//                             <div className="form-text">
//                               {imageLoading ? (
//                                 <span className="text-primary">
//                                   <i className="fa-solid fa-spinner fa-spin me-1"></i>
//                                   Uploading image...
//                                 </span>
//                               ) : (
//                                 "Upload an image for the service"
//                               )}
//                             </div>

//                             {formData.image && (
//                               <div className="mt-3 position-relative">
//                                 <div className="alert alert-success p-2">
//                                   <strong>Image Preview:</strong>
//                                 </div>
//                                 <img
//                                   src={formData.image}
//                                   alt="Service Preview"
//                                   style={{
//                                     maxHeight: "200px",
//                                     maxWidth: "100%",
//                                     borderRadius: "8px",
//                                     border: "2px solid #dee2e6",
//                                     objectFit: "cover",
//                                   }}
//                                 />
//                                 <button
//                                   type="button"
//                                   onClick={removeImage}
//                                   className="btn btn-danger btn-sm position-absolute"
//                                   style={{ top: "35px", right: "10px" }}
//                                 >
//                                   <i className="fa-solid fa-times"></i>
//                                 </button>
//                               </div>
//                             )}
//                           </div>

//                           {/* Heading Input */}
//                           <div className="col-md-6 mt-3">
//                             <label htmlFor="heading">
//                               Heading<span className="text-danger">*</span>
//                             </label>
//                             <input
//                               type="text"
//                               id="heading"
//                               className="form-control"
//                               name="heading"
//                               value={formData.heading}
//                               onChange={handleChange}
//                               placeholder="Enter service heading..."
//                               required
//                             />
//                             <div className="form-text">
//                               Enter the main heading for the service
//                             </div>
//                           </div>

//                           {/* Subheading Textarea */}
//                           <div className="col-md-12 mt-3">
//                             <label htmlFor="subheading">
//                               Subheading<span className="text-danger">*</span>
//                             </label>
//                             <textarea
//                               id="subheading"
//                               className="form-control"
//                               name="subheading"
//                               value={formData.subheading}
//                               onChange={handleChange}
//                               rows="4"
//                               placeholder="Enter service subheading or description..."
//                               required
//                             ></textarea>
//                             <div className="form-text">
//                               Enter a detailed subheading or description for the
//                               service
//                             </div>
//                           </div>
//                         </div>

//                         {/* Submit Buttons */}
//                         <div className="col-md-12 mt-4">
//                           <button
//                             type="submit"
//                             className="btn btn-primary"
//                             disabled={isSubmitting || imageLoading}
//                           >
//                             {isSubmitting ? (
//                               <>
//                                 <span
//                                   className="spinner-border spinner-border-sm mr-2"
//                                   role="status"
//                                   aria-hidden="true"
//                                 ></span>
//                                 Updating...
//                               </>
//                             ) : (
//                               "Update Service"
//                             )}
//                           </button>
//                           <button
//                             type="button"
//                             className="btn btn-secondary ml-2"
//                             onClick={handleCancel}
//                           >
//                             Cancel
//                           </button>
//                         </div>
//                       </form>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </section>
//           )}

//           {/* List Section */}
//           <section className="chartBox_area mt-4">
//             <div className="row">
//               <div className="col-lg-12">
//                 <div className="card">
//                   <div className="card-header">
//                     <h5 className="mb-0">Personal Services List</h5>
//                   </div>
//                   <div className="card-body">
//                     {loading ? (
//                       <div className="text-center py-5">
//                         <div
//                           className="spinner-border text-primary"
//                           role="status"
//                         >
//                           <span className="sr-only">Loading...</span>
//                         </div>
//                         <p className="mt-2">Loading personal services...</p>
//                       </div>
//                     ) : personalServices.length === 0 ? (
//                       <div className="text-center py-5">
//                         <p className="text-muted">No personal services found</p>
//                       </div>
//                     ) : (
//                       <DataTable
//                         columns={columns}
//                         data={personalServices}
//                         pagination
//                         paginationPerPage={10}
//                         paginationRowsPerPageOptions={[10, 25, 50, 100]}
//                         customStyles={customStyles}
//                         highlightOnHover
//                         pointerOnHover
//                         noDataComponent="No personal services found"
//                       />
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ManagePersonalService;

import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HttpClientXml from "../utils/HttpClientXml";
import HomeService from "../Services/HomeService";
import moment from "moment";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManagePersonalService() {
  const [personalServices, setPersonalServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [serviceID, setServiceID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({
    image: "",
    heading: "",
    subheading: "",
  });

  // Function to show subheading in popup
  const showSubheadingPopup = (subheading, title = "Subheading") => {
    Swal.fire({
      title: title,
      html: `
        <div style="text-align: left; max-height: 400px; overflow-y: auto; padding: 10px;">
          <p style="white-space: pre-wrap; word-wrap: break-word;">${
            subheading || "No subheading available"
          }</p>
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false,
      width: "600px",
      customClass: {
        popup: "description-popup",
      },
    });
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={row.image || "/placeholder-image.png"}
          alt="Service"
          width="60"
          height="60"
          style={{
            borderRadius: "8px",
            objectFit: "cover",
            border: "1px solid #dee2e6",
          }}
        />
      ),
      center: true,
    },
    {
      name: "Heading",
      selector: (row) => row.heading,
      sortable: true,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span style={{ minWidth: "50px" }}>
            {row.heading || <span className="text-muted">No heading</span>}
          </span>
        </div>
      ),
    },
    {
      name: "Subheading",
      cell: (row) => {
        const subheading = row.subheading || "";
        const shortSubheading =
          subheading.length > 10
            ? `${subheading.substring(0, 10)}...`
            : subheading;

        return (
          <div className="d-flex align-items-center">
            <span className="me-2" style={{ minWidth: "50px" }}>
              {shortSubheading || (
                <span className="text-muted">No subheading</span>
              )}
            </span>
            {subheading.length > 10 && (
              <button
                type="button"
                className="btn btn-sm p-0"
                onClick={() =>
                  showSubheadingPopup(subheading, "Service Subheading")
                }
                title="View full subheading"
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#007bff",
                  fontSize: "16px",
                }}
              >
                <i className="fa-solid fa-eye"></i>
              </button>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Created Date",
      selector: (row) =>
        new Date(
          row.createdAt || row.createdOn || row.updatedAt
        ).toLocaleDateString(),
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            onClick={() => handleEdit(row)}
            className="btn btn-sm me-2"
            style={{
              background: "transparent",
              border: "none",
              color: "rgb(133, 218, 79)",
            }}
          >
            <i className="fa-solid fa-pen-to-square fs-5"></i>
          </button>
          <button
            title="Delete"
            onClick={() => handleDelete(row._id)}
            className="btn btn-sm"
            style={{
              background: "transparent",
              border: "none",
              color: "#dc3545",
            }}
          >
            <i className="fa-solid fa-trash-can fs-5"></i>
          </button>
        </div>
      ),
      center: true,
    },
  ];

  // Fetch all personal services
  const fetchPersonalServices = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getPersonalService();
      console.log("Personal services data:", res.data);
      setPersonalServices(res.data);
    } catch (error) {
      console.error("Error fetching personal services:", error);
      toast.error("Failed to load personal services!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPersonalServices();
  }, []);

  // Handle edit button click
  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({
      image: row.image || "",
      heading: row.heading || "",
      subheading: row.subheading || "",
    });
    setServiceID(row._id);
  };

  // Handle delete button click with SweetAlert confirmation
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Personal Service?",
      text: "Are you sure you want to delete this personal service?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const res = await HomeService.deletePersonalService(id);
        if (res?.status) {
          Swal.fire(
            "Deleted!",
            "Personal service has been deleted.",
            "success"
          );
          fetchPersonalServices();
        } else {
          toast.error(res?.message || "Failed to delete service");
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete personal service.", "error");
      }
    }
  };

  // Handle image upload
  const handleImageUpload = async (e) => {
    if (!e.target.files[0]) return;

    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setEditData({ ...editData, image: res.image });
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    }
  };

  // Handle form submission for update
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!editData.heading.trim()) {
      toast.error("Please enter a heading.");
      return;
    }

    if (!editData.subheading.trim()) {
      toast.error("Please enter a subheading.");
      return;
    }

    if (!editData.image) {
      toast.error("Please upload an image.");
      return;
    }

    try {
      // Prepare update data
      const data = {
        image: editData.image,
        heading: editData.heading.trim(),
        subheading: editData.subheading.trim(),
      };

      console.log("Updating personal service with data:", data);

      const res = await HomeService.updatePersonalService(serviceID, data);

      if (res?.status) {
        toast.success("Personal service updated successfully!");
        setIsEdit(false);
        setEditData({ image: "", heading: "", subheading: "" });
        fetchPersonalServices();
      } else {
        toast.error(res?.message || "Failed to update personal service.");
      }
    } catch (error) {
      toast.error("Failed to update personal service.");
      console.error("Error updating personal service:", error);
    }
  };

  // Handle cancel edit
  const handleCancel = () => {
    setIsEdit(false);
    setEditData({ image: "", heading: "", subheading: "" });
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit ? (
            <section className="chartBox_area">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">Edit Personal Service</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* Image Upload Section */}
                      <div className="col-md-6 mt-3">
                        <label>
                          Image<span className="text-danger">*</span>
                        </label>
                        {editData.image && (
                          <div className="mt-2 mb-2">
                            <img
                              src={editData.image}
                              alt="Service Preview"
                              style={{
                                maxHeight: "150px",
                                maxWidth: "100%",
                                borderRadius: "8px",
                                border: "2px solid #dee2e6",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        )}
                        <input
                          type="file"
                          className="form-control"
                          onChange={handleImageUpload}
                          accept="image/*"
                        />
                        <small className="text-muted">
                          Upload service image
                        </small>
                      </div>

                      {/* Heading Input */}
                      <div className="col-md-6 mt-3">
                        <label htmlFor="heading">
                          Heading<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="heading"
                          className="form-control"
                          value={editData?.heading || ""}
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              heading: e.target.value,
                            }))
                          }
                          placeholder="Enter service heading..."
                          required
                        />
                        <small className="text-muted">
                          Enter the main heading for the service
                        </small>
                      </div>

                      {/* Subheading Textarea */}
                      <div className="col-md-12 mt-3">
                        <label htmlFor="subheading">
                          Subheading<span className="text-danger">*</span>
                        </label>
                        <textarea
                          id="subheading"
                          className="form-control"
                          value={editData?.subheading || ""}
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              subheading: e.target.value,
                            }))
                          }
                          rows="4"
                          placeholder="Enter service subheading..."
                          required
                          style={{ height: "172px" }}
                        ></textarea>
                        <small className="text-muted">
                          Enter a detailed subheading for the service
                        </small>
                      </div>
                    </div>

                    <div className="mt-4 pt-3 border-top">
                      <button
                        type="submit"
                        className="btn btn-primary me-3"
                        style={{
                          background: "rgb(133, 218, 79)",
                          border: "none",
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-floppy-disk me-2"></i>
                        Save Changes
                      </button>
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="btn btn-secondary"
                        style={{
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-times me-2"></i>
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          ) : (
            <>
              <div className="mt-5">
                <div style={headLineStyle} className="page-headline">
                  Manage Personal Services
                </div>
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading personal services...</p>
                  </div>
                ) : personalServices.length > 0 ? (
                  <div className="card">
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={personalServices}
                        pagination
                        responsive
                        highlightOnHover
                        striped
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        noDataComponent={
                          <div className="text-center py-4">
                            <i className="fa-solid fa-briefcase fa-2x text-muted mb-3"></i>
                            <p>No personal services found</p>
                          </div>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="card">
                    <div className="card-body text-center py-5">
                      <i className="fa-solid fa-briefcase fa-3x text-muted mb-3"></i>
                      <h5>No Personal Services Available</h5>
                      <p className="text-muted">
                        There are no personal services to display at the moment.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Add CSS for the popup */}
      <style>
        {`
          .description-popup .swal2-popup {
            max-width: 600px;
          }
          .description-popup .swal2-html-container {
            overflow: hidden;
          }
          .rtl .btn {
            margin-left: 5px;
            margin-right: 5px;
          }
        `}
      </style>
    </>
  );
}

export default ManagePersonalService;
